export const COPYV2 = {
  FOOTER: {
    COPYRIGHT: `© ${new Date().getFullYear()} Walmart Inc.`,
  },
  CAMPAIGN_LIST_WRAPPER: {
    HEADER_TITLE: "General Announcement",
    HEADER_SUBTITLE:
      "Access all your messages associated with folders in the left-side view. Easily review, track status, follow up on actions, or create new messages seamlessly.",
  }
};
